/* eslint-disable import/prefer-default-export */
export const SET_RESOURCE = 'SET_RESOURCE'
